export const displayMoney = (n) => {
    const numFormat = new Intl.NumberFormat('pl-PL', {
        style: 'currency',
        currency: 'PLN',
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
    });

    return numFormat.format(n);
};

export const calculateDiscount = (discountedPrice, originalPrice) => {
    if (originalPrice <= 0) return 0;

    const discountedPercent = ((originalPrice - discountedPrice) / originalPrice) * 100;

    return Math.round(discountedPercent);
};

export const calculateTotal = (arr) => {
    const total = arr.reduce((accum, val) => {
        if (typeof val !== 'number' || isNaN(val)) {
            console.error('Invalid value in array:', val);
            return accum;
        }
        return accum + val;
    }, 0);

    return total;
};
